
<div *ngIf="init">
    <dynamic-form [whiteFields]="false" [layout]="alignMent" 
    [customField13]="0" [fields]="regConfig"
     (submitSubForm)="submitValue($event)">
    </dynamic-form>
</div>